export const iconFontAwesomeEnergyPlugCircleBolt = (
	<i className="fa-solid fa-plug-circle-bolt"></i>
);
